App.namespace('es6.views.login.facebook', function () {
  const api = function facebook(options = {}) {
    const {
      csrfToken,
      facebookUrl,
      redirectUrl,
      defaultRedirectUrl = '/account/enquiries/current',
      trackingParams = {},
    } = options;

    $('#modal-facebook-login').on('click', function (e) {
      e.preventDefault();

      $('#modal-facebook-error-message').addClass('hidden');

      const cb = function(response) {
        if (response.status === 'connected') {
          $.ajax({
            url: facebookUrl,
            type: 'POST',
            data: {
              'token': response.authResponse.accessToken,
              '_token': csrfToken,
              trackingParams: typeof trackingParams === 'function' ? trackingParams() : trackingParams,
            },
            success() {
              if (redirectUrl && redirectUrl.indexOf(location.origin) === 0) {
                window.location = redirectUrl;
              }

              window.location = defaultRedirectUrl
            },
            error(jqXHR) {
              const refusalMessage = App.es6.shared.social_login_error.getRefusalMessage(jqXHR);

              if (refusalMessage) {
                App.es6.shared.social_login_error.show(refusalMessage);
                return;
              }

              $('#modal-facebook-error-message').removeClass('hidden');
            },
          });
        } else {
          // console.info('User is logged out');
        }
      };

      FB.login(cb, {
        scope: 'email,public_profile',
        return_scopes: true,
        auth_type: 'rerequest',
      })
    });
  };

  return api;
});
